import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 宁波港接口
 **********************************************************************************/
export default {
    /**
     * 新建模版
     * @param {String} orderName 模版名
     * @param {String} startTime 开始时间
     * @param {String} endTime 结束时间
     * @param {String} flowStart 没有使用
     * @param {String} flowEnd 没有使用
     * @param {String} deviceId 设备id列表
     * @param {String} cycle 周期
     */
    saveTemplate: (orderName, startTime, endTime, flowStart, flowEnd, deviceArray, cycle, success, failure) => {
        var workflow = JSON.stringify({
            orderName,
            startTime,
            endTime,
            flowStart,
            flowEnd,
            deviceArray,
            cycle
        });
        Axios.post('/nbg/addwfModel.do', {
            workflow
        }, success, failure);
    },
    /**
     * 修改模版
     * @param {String} orderName 模版名
     * @param {String} startTime 开始时间
     * @param {String} endTime 结束时间
     * @param {String} cycle 周期
     */
    updateTemplate: (id, orderName, startDate, endDate, type, tag, success, failure) => {
        var workflow = {
            id,
            type,
            tag,
            startDate,
            endDate,
            orderName
        };
        Axios.post('/nbg/updateOrder.do', workflow, success, failure);
    },
    /**
     * 修改模版
     * @param {String} orderName 模版名
     * @param {String} startTime 开始时间
     * @param {String} endTime 结束时间
     * @param {String} cycle 周期
     */
    deleteTemplate: (wfId, success, failure) => {
        var workflow = {
            wfId
        };
        Axios.post('/nbg/delwfModel.do', workflow, success, failure);
    },
    /**
     * 查询工单模板列表
     * @param {tokon} 
     * @param {pageIndex} :页码
     * @param {pageSize} :页长
     */
    getTemplateList: (tokon, pageIndex, pageSize, success, failure) => {
        Axios.post('/nbg/workflowlist.do', {
            tokon,
            pageIndex,
            pageSize
        }, success, failure)
    },
    /**
     * 查询工单列表
     * @param {pageIndex} :页码
     * @param {pageSize} :页长
     * @param {state} :工单状态 
     * @param {param} :工单名、id 
     * @param {startTime} :开始时间
     * @param {endTime} :结束时间
     */
    getWorkorderList: (pageIndex, pageSize, status, param, startTime, endTime, success, failure) => {
        if (status == 0 || status == '0') {
            status = '';
        }
        var p = {
            pageIndex,
            pageSize,
            status,
            param,
            startTime,
            endTime
        }
        Axios.post('/nbg/getOrderList.do', p, success, failure)
    },
    /**
     * 关闭工单
     * @param {id} :工单id
     * @param {capacity} :产量
     * @param {efficiency} :能效，不应该放这里，需要去掉
     */
    closeWorkorder: (id, capacity, efficiency, success, failure) => {
        var p = {
            id,
            capacity,
            efficiency
        }
        Axios.post('/nbg/finishOrder.do', p, success, failure)
    },
    /**
     * 新增保养记录
     * @param {deviceId} :工单id
     * @param {name} :名称
     * @param {isRemind} :是否提醒保养（1==提醒；2==不提醒）
     * @param {nextTime}：下次时间
     */
    addRepair: (deviceId, name, isRemind, nextTime, success, failure) => {
        var p = {
            deviceId,
            name,
            isRemind,
            nextTime
        }
        Axios.post('/nbg/addMainTain.do', p, success, failure)
    },
    /**
     * 删除保养记录
     * @param {id} :工单id
     */
    delRepair: (id, success, failure) => {
        var p = {
            id
        }
        Axios.post('/nbg/delMainTain.do', p, success, failure)
    },
    /**
     * 查询保养列表
     * @param {pageIndex} :页码
     * @param {pageSize} :页长
     * @param {state} :保养状态 
     * @param {startTime} :开始时间
     * @param {endTime} :结束时间
     */
    getRepairList: (pageIndex, pageSize, status, startTime, endTime, success, failure) => {
        var p = {
            pageIndex,
            pageSize,
            status,
            startTime,
            endTime
        }
        Axios.post('/nbg/maintainList.do', p, success, failure)
    },
    /**
     * 保养
     * @param {id} :id
     * @param {deviceId} :没有用到
     * @param {records} :保养状态 
     * @param {nextTime} :下次时间
     */
    repair: (id, deviceId, records, nextTime, success, failure) => {
        var p = {
            id,
            deviceId,
            records,
            nextTime
        }
        Axios.post('/nbg/finishMainTain.do', p, success, failure)
    },
    /**
     * 线损分析
     * @param {devicesOne} :第一组表设备号（多个以逗号分开）
     * @param {devicesTwo} :第二组表设备号（多个以逗号分开）
     * @param {startDate} :比较开始时间
     * @param {endDate} :比较结束时间
     */
    lossCompair: (devicesOne, devicesTwo, startDate, endDate, success, failure) => {
        var p = {
            devicesOne,
            devicesTwo,
            startDate,
            endDate
        }
        Axios.post('/nbg/linelost/calculation.do', p, success, failure)
    },
    /**
     * 工单详情
     * @param {id} :工单ID
     */
    orderDetail: (id, success, failure) => {
        var p = {
            id
        }
        Axios.post('/nbg/orderDetail.do', p, success, failure)
    },
    /**
     * 列出所有泊位
     */
    findAllDicBerth: (success, failure) => {
        var p = {}
        Axios.post('/ningbo/findAllDicBerth.do', p, success, failure)
    },
    /**
     * 列出所有堆声
     */
    findAllDicArea: (success, failure) => {
        var p = {}
        Axios.post('/ningbo/findAllDicArea.do', p, success, failure)
    },
    /**
     * 列出所有操作类型
     */
    findAllDicType: (success, failure) => {
        var p = {}
        Axios.post('/ningbo/findAllDicType.do', p, success, failure)
    },
    /**
     * 列出所有码头设备
     */
    findAllDicDockDev: (success, failure) => {
        var p = {}
        Axios.post('/ningbo/findAllDicDockDev.do', p, success, failure)
    },
    /**
     * 删除泊位
     */
    delDicBerth: (id, success, failure) => {
        var p = {
            id
        }
        Axios.post('/ningbo/deleteDicBerth.do', p, success, failure)
    },
    /**
     * 删除堆场
     */
    delDicArea: (id, success, failure) => {
        var p = {
            id
        }
        Axios.post('/ningbo/deleteDicArea.do', p, success, failure)
    },
    /**
     * 删除类型
     */
    delDicType: (id, success, failure) => {
        var p = {
            id
        }
        Axios.post('/ningbo/deleteDicType.do', p, success, failure)
    },
    /**
     * 删除码头设备
     */
    delDicDockDev: (id, success, failure) => {
        var p = {
            id
        }
        Axios.post('/ningbo/deleteDicDockDev.do', p, success, failure)
    },
    /**
     * 新类型
     */
    newDicType: (name, success, failure) => {
        var p = {
            name
        }
        Axios.post('/ningbo/newDicType.do', p, success, failure)
    },
    /**
     * 新堆场
     */
    newDicArea: (name, success, failure) => {
        var p = {
            name
        }
        Axios.post('/ningbo/newDicArea.do', p, success, failure)
    },
    /**
     * 新泊位
     */
    newDicBerth: (name, success, failure) => {
        var p = {
            name
        }
        Axios.post('/ningbo/newDicBerth.do', p, success, failure)
    },
    
    /**
     * 新码头设备
     */
    newDicDockDev: (name, success, failure) => {
        var p = {
            name
        }
        Axios.post('/ningbo/newDicDockDev.do', p, success, failure)
    },
    /**
     * 列出所有皮带流程
     */
    findAllBelt: (search, pageIndex, pageSize, success, failure) => {
        var p = {
            search,
            pageIndex,
            pageSize,
        }
        Axios.post('/ningbo/findAllBelt.do', p, success, failure)
    },
    /**
     * 列出所有皮带流程，按能将排序
     */
    findAllBeltOrderByEfficiency: (search, pageIndex, pageSize, success, failure) => {
        var p = {
            search,
            pageIndex,
            pageSize
        }
        Axios.post('/ningbo/findAllBeltOrderByEfficiency.do', p, success, failure)
    },
    /**
     * 新建皮带流程
     */
    newBelt: (name, remark, deviceNo, deviceName, success, failure) => {
        var p = {
            name,
            remark,
            deviceNo,
            deviceName
        }
        Axios.post('/ningbo/newBelt.do', p, success, failure)
    },
    /**
     * 修改皮带流程
     */
    updateBelt: (id, name, remark, deviceNo, deviceName, success, failure) => {
        var p = {
            id,
            name,
            remark,
            deviceNo,
            deviceName
        }
        Axios.post('/ningbo/updateBelt.do', p, success, failure)
    },
    /**
     * 删除皮带流程
     */
    delBelt: (id, success, failure) => {
        var p = {
            id
        }
        Axios.post('/ningbo/deleteBelt.do', p, success, failure)
    },
    /**
     * 导入excel
     * 行格式： {
     *          name:'皮带流程名称',
     *          deviceNo:'设备列表，逗号分割',
     *          orderid:'序号'
     *          }
     */
    importBelts: (belts, success, failure) => {
        var p = {
            belts
        }
        Axios.post('/ningbo/importBelts.do', p, success, failure)
    },
    /**
     * 列出所有工单（初始化）
     */
    findAllWorkorder: (pageIndex, pageSize, success, failure) => {
        var p = {
            pageIndex,
            pageSize
        }
        console.log("=====findAllWorkorder.do:" + JSON.stringify(p));
        Axios.post('/ningbo/findAllWorkorder.do', p, success, failure)
    },
    /**
     * 列出所有工单（条件查询）
     */
    findAllWorkorderWithCondition: (no, beltId, berthId, areaId, beginTime, endTime, pageIndex, pageSize, success, failure) => {
        var p = {
            no,
            beltId,
            berthId,
            areaId,
            beginTime,
            endTime,
            pageIndex,
            pageSize
        }
        Axios.post('/ningbo/findAllWorkorderWithCondition.do', p, success, failure)
    },
    /**
     * 列出所有工单（历史）
     */
    findAllHistoryWorkorder: (no, beltId, beginTime, endTime, pageIndex, pageSize, success, failure) => {
        var p = {
            no,
            beltId,
            beginTime,
            endTime,
            pageIndex,
            pageSize
        }
        Axios.post('/ningbo/findAllHistoryWorkorder.do', p, success, failure)
    },
    /**
     * 新建工单
     */
    newWorkorder: (no, beginTime, beltId, berthId, areaId, typeId, number, dockDevNos, dockDevNames, success, failure) => {
        var p = {
            no,
            beginTime,
            beltId,
            berthId,
            areaId,
            typeId,
            number,
            dockDevNos,
            dockDevNames,
        }
        Axios.post('/ningbo/newWorkorder.do', p, success, failure)
    },
    /**
     * 修改工单
     */
    updateWorkorder: (id, no, beginTime, beltId, berthId, areaId, typeId, number, success, failure) => {
        var p = {
            id,
            no,
            beginTime,
            beltId,
            berthId,
            areaId,
            typeId,
            number
        }
        Axios.post('/ningbo/updateWorkorder.do', p, success, failure)
    },
    /**
     * 删除工单
     */
    delWorkorder: (id, success, failure) => {
        var p = {
            id
        }
        Axios.post('/ningbo/deleteWorkorder.do', p, success, failure)
    },
    /**
     * 暂停工单
     */
    pauseWorkorder: (id, event, success, failure) => {
        var p = {
            id,
            event
        }
        Axios.post('/ningbo/pauseWorkorder.do', p, success, failure)
    },
    /**
     * 重启工单
     */
    restartWorkorder: (id, success, failure) => {
        var p = {
            id
        }
        Axios.post('/ningbo/restartWorkorder.do', p, success, failure)
    },
    /**
     * 关闭工单
     */
    closeWorkorder: (number, id, success, failure) => {
        var p = {
            number,
            id
        }
        Axios.post('/ningbo/closeWorkorder.do', p, success, failure)
    },
    /**
     * 查询所有工单事件
     */
    findAllEventByWorkorderId: (id, success, failure) => {
        var p = {
            id
        }
        Axios.post('/ningbo/findAllEventByWorkorderId.do', p, success, failure)
    },
    /**
     * 查询所有设备事件
     */
    findAllDevEventsByBeltId: (beltId, beginTime, endTime, success, failure) => {
        var p = {
            beltId,
            beginTime,
            endTime
        }
        Axios.post('/ningbo/findAllDevEventsByBeltId.do', p, success, failure)
    },
    /**
     * 查询历史数据（小时）
     */
    findHourData: (beltId, beginTime, endTime, success, failure) => {
        var p = {
            beltId,
            beginTime,
            endTime
        }
        Axios.post('/ningbo/findHourData.do', p, success, failure)
    },
}